import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { MessagingContext } from "../context/messaging-layer";

export default class TreatmentCell extends PureComponent {
  handleClick = () => {
    const {
      field,
      components,
      appData: { settings }
    } = this.props;
    this.context.showDialog({
      actions: [
        {
          label: settings.translations.cancel,
          className: "secondary",
          name: "close-dialog"
        }
      ],
      content: {
        title: field.title,
        children: (
          <>
            <components.Button
              label={settings.translations.edit_treatment}
              onClick={() => this.handleEditClick(field.title)}
              name='editTreatment'
            />
            <components.Button
              label={settings.translations.remove_treatment}
              onClick={() => this.handleDeleteClick(field.title)}
              name='removeTreatment'
            />
          </>
        )
      },
      fullscreen: false
    });
  };

  handleEditClick = name => {
    const {
      appData: {
        data,
        values,
        screenIndex,
        screenParams,
        dermTreatmentData,
        setTreatmentToEdit,
        nextScreen
      },
      field
    } = this.props;

    setTreatmentToEdit({
      name,
      index: Object.values(dermTreatmentData)[0].indexOf(name)
    });

    nextScreen({
      data,
      action: {
        type: field.actionToEdit.type,
        value: field.actionToEdit.value
      },
      screenIndex,
      formState: values,
      screenParams
    });
    this.context.hideDialog();
  };

  handleDeleteClick = name => {
    const { appData } = this.props;
    appData.deleteTreatmentData(name);

    this.context.hideDialog();
  };

  render() {
    const {
      field: { name, title, usingNow, formulation, frequency },
      components: { Text, Dot },
      appData: { settings }
    } = this.props;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginRight: "20px"
        }}
        className='websdk-mb-8'
        data-testid={`treatment-cell-${name}`}
        data-usingnow={usingNow}
      >
        <div className='websdk--mb-8'>
          <Text>
            <button
              className='treatment-button'
              name={`treatment-${name}`}
              onClick={this.handleClick}
              type='button'
              aria-label={settings.translations.edit_or_remove_treatment}
            >
              {title}
            </button>
            <span className='websdk-block websdk-text-gray-200'>
              {[formulation, frequency].filter(item => item.trim()).join(", ")}
            </span>
          </Text>
        </div>
        {usingNow === "YES" && <Dot name='treatment-using-now' />}
      </div>
    );
  }
}

TreatmentCell.propTypes = {
  field: PropTypes.objectOf(PropTypes.object).isRequired,
  components: PropTypes.arrayOf(PropTypes.node).isRequired,
  appData: PropTypes.objectOf(PropTypes.object).isRequired
};

TreatmentCell.contextType = MessagingContext;
